export class ListaBeneficiariosViewModel {
  titular!: any[];
  dependente!: any[]
}
